import {
  browserSupportsWebAuthn,
  platformAuthenticatorIsAvailable,
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";

import { api } from "./api.js";

/**
 * Face ID, Touch ID, a phone's screen lock — the browser half.
 *
 * Always beside the email link, never instead of it: a browser that cannot do
 * passkeys just never shows the button.
 */

export function passkeysSupported(): boolean {
  return browserSupportsWebAuthn();
}

/** Whether this device itself can hold one — what makes "Use Face ID?" worth asking. */
export async function deviceCanHoldPasskey(): Promise<boolean> {
  if (!browserSupportsWebAuthn()) return false;
  return platformAuthenticatorIsAvailable();
}

/**
 * The person closing the Face ID sheet is not an error worth a message: they
 * know what they did. Everything else is.
 */
export function wasCancelled(error: unknown): boolean {
  return error instanceof Error && (error.name === "NotAllowedError" || error.name === "AbortError");
}

export async function signInWithPasskey(): Promise<void> {
  const optionsJSON = await api.passkeyLoginOptions();
  const response = await startAuthentication({ optionsJSON });
  await api.passkeyLoginVerify(response);
}

export async function addPasskey(): Promise<void> {
  const optionsJSON = await api.passkeyRegisterOptions();
  const response = await startRegistration({ optionsJSON });
  await api.passkeyRegisterVerify(response);
}
